export default "__VITE_ASSET__CQOP582C__"